import React, { Component } from 'react';

import {
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import {connect} from 'react-redux';
import Setting from './Setting';
import Home from './Home';
import History from './History';
import Information from './Information';
import PasswordConfirm from './PasswordConfirm';
import LoadingScreen from './LoadingScreen';
import { RequestGet } from '../../apiClient/api/RequestService';
import UnreceivedTrans from "./UnreceivedTrans";

class Main extends Component {
    constructor(props){
        super(props);
        this.state = {
            isTokenValid: true,
            isAuthenticating: true,
        }
    }

    authenticated= (type) => {
        this.setState({
            isAuthenticating: false,
            isTokenValid: type
        })
        if(type === false){
            this.props.dispatch({type: "RESET_QUEUE"});
            this.props.dispatch({type: "USER_LOGOUT"});
        }
    }

    authenticate = async () => {
        const {token} = this.props;
		if (!token) {
			return this.authenticated(false);
        }

        // const res = await RequestGet('/v1/account/check-login', token)
        // if (res?.return_code === 1) {
        //     return this.authenticated(true);
        // }
        return this.authenticated(true);
    }

    componentDidMount(){
        this.authenticate();
    }

	render() {
        if(!this.state.isTokenValid) return <Redirect to="/login"/> 
        if(this.state.isAuthenticating) return <LoadingScreen/>

		return (
            <React.Fragment>
                <Switch>
                    <Route exact path='/information' component={Information}/>
                    <Route exact path='/setting' component={Setting}/>
                    <Route exact path='/history' component={History}/>
                    <Route exact path='/unreceived' component={UnreceivedTrans} />
                    <Route exact path='/home' component={Home}/>
                    <Route exact path='/passwordconfirm' component={PasswordConfirm}/>
                    <Redirect from='/' to='/home' />  
                </Switch>
            </React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.loginData.token,
	}
};

export default connect(mapStateToProps)(Main);
